import { PageLoader as PageLoaderComponent } from '../../components/page-loader/PageLoader';

import styles from './page-loader.module.scss';
export const PageLoader = () => (
  <div className={styles['main']}>
    <div className={styles['content']}>
      <PageLoaderComponent />
    </div>
  </div>
);
